<script setup lang="ts">
// Fix round 1 (task-11-review.md, Important #1): the JAPAN inline-confirm block was
// byte-identical between FundAccessGrid.vue's desktop table and phone card. Extracted here so the
// spec-mandated copy and the Grant/Cancel buttons live in exactly one place. Behaviour and markup
// are unchanged — callers pass their own data-testids so existing tests/the Playwright smoke still
// find the same elements at the same selectors.
// Generalised from a JAPAN-only component (PR 0, spec 2026-10-05): `fundLabel` replaces the
// hard-coded "Japan" copy. Today JAPAN is the only gated fund, so rendered copy is unchanged.
defineProps<{
  label: string
  fundLabel: string
  confirmTestid: string
  grantTestid: string
  cancelTestid: string
}>()
defineEmits<{ grant: []; cancel: [] }>()
</script>

<template>
  <div class="fa-confirm" role="group" :data-testid="confirmTestid">
    <p>Granting {{ fundLabel }} lets {{ label }} see {{ fundLabel }} and puts {{ fundLabel }} legs in their plan once their {{ fundLabel }} weight is on. {{ fundLabel }} is still in rollout.</p>
    <button type="button" class="fa-btn fa-btn-primary" :data-testid="grantTestid" @click="$emit('grant')">Grant</button>
    <button type="button" class="fa-btn" :data-testid="cancelTestid" @click="$emit('cancel')">Cancel</button>
  </div>
</template>

<style scoped>
.fa-confirm { background: #1c2128; border: 1px solid #d29922; border-radius: 6px; padding: 0.75rem; text-align: left; }
.fa-confirm p { margin: 0 0 0.5rem; }
.fa-btn { min-height: 44px; padding: 0 1rem; margin-right: 0.5rem; background: #21262d; color: #c9d1d9; border: 1px solid #30363d; border-radius: 6px; cursor: pointer; }
.fa-btn-primary { background: #238636; border-color: #2ea043; color: #fff; }
</style>
